import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, DatePicker, Form } from 'antd';

export const ReviewedAt: React.FC = () => {
	return (
		<Col xs={24}>
			<Form.Item name={['reviewed_at']} label={I18n.get('Reviewed date')} labelCol={{ span: 24 }}>
				<DatePicker.RangePicker
					style={{ width: '100%' }}
					format="DD-MM-YYYY"
					disabledDate={(current) => current && current.valueOf() >= Date.now()}
				/>
			</Form.Item>
		</Col>
	);
};
